<mat-progress-spinner class="example-margin" color="main" [mode]="mode" [value]="value" diameter="22">
</mat-progress-spinner>